import React, { useState } from 'react';
import PicklistButton from '../../container/buttons/PicklistButton';
import { CentsPalette } from '../../../../utils/colors';

export interface PicklistItem<T> {
  key: string
  value: T
}
interface Props<T> {
  picks: PicklistItem<T>[]
  value: T | undefined
  className?: string
  visibleListClassname?: string
  empty?: {
    enabled: boolean
    label: string
  }
  onChange: (value: PicklistItem<T> | undefined) => void
  renderer: (item: T) => JSX.Element
}

// TODO: Unite with PicklistFilter
export function Picklist<T>({ picks, value, className, visibleListClassname, empty, onChange, renderer }: Props<T>): JSX.Element {
  const [isPicklistVisible, setIsPicklistVisible] = useState(false)

  const togglePicklist = () => {
    setIsPicklistVisible(!isPicklistVisible)
  }

  const handleSelect = (pick: PicklistItem<T> | undefined) => {
    onChange(pick)
    setIsPicklistVisible(false)
  }

  return (
    <div className={"picklist w-full relative h-10 rounded-2xl".concat(className ? ` ${className}` : '')}>
      <PicklistCustomButton onClick={togglePicklist}>
        {value ? renderer(value) : <>{empty?.label ?? ''}</>}
      </PicklistCustomButton>

      <button onClick={togglePicklist}>
        <svg id="picklist-arrow" className={`z-30 absolute right-4 top-2 transition-transform duration-300 ${isPicklistVisible ? "rotate-180" : "rotate-0"}`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 8.01777L11.6161 14.6339C12.1043 15.122 12.8957 15.122 13.3839 14.6339L20 8.01777" stroke={CentsPalette.cents_black} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>

      <li className={`${isPicklistVisible ? `max-h-[10vh]`.concat(visibleListClassname ? ` ${visibleListClassname}` : '') : "max-h-0"} z-40 absolute top-12 w-full bg-cents-white rounded-2xl list-none overflow-y-auto transition-[max-height] duration-700`}>
        {empty?.enabled && value && <ul >
          <PicklistButton label={empty?.label ?? ''} isSelected={false} onClickFunction={() => handleSelect(undefined)} />
        </ul>}
        {picks
          .filter(pick => pick.value !== value)
          .map(pick => (
            <ul key={pick.key}>
              <PicklistCustomButton onClick={() => handleSelect(pick)}>
                {renderer(pick.value)}
              </PicklistCustomButton>
            </ul>
          ))
        }
      </li>
    </div>
  );
};

export function PicklistCustomButton({ children, onClick }: { children: JSX.Element, onClick: () => void }): JSX.Element {
  return (<button onClick={onClick} className="z-20 relative flex justify-start pl-4 items-center text-cents-black bg-cents-white h-10 w-full rounded-2xl text-sm">
    <div className={`selected break-words`}>
      {children}
    </div>
  </button>)
}